"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComments = exports.CommentsProvider = exports.CommentsFull = exports.AnnotationsMask = exports.AnnotationsOverlay = void 0;

// Polyfills
require('regenerator-runtime/runtime');

if (!Node.prototype.contains) {
  Node.prototype.contains = function contains(node) {
    if (node) {
      var tmpNode = node;

      do {
        if (this === tmpNode) {
          return true;
        }

        tmpNode = tmpNode && tmpNode.parentNode;
      } while (tmpNode);
    }

    return false;
  };
}

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
} // Components


var AnnotationsOverlay = require('./views/Annotations').default;

exports.AnnotationsOverlay = AnnotationsOverlay;

var AnnotationsMask = require('./views/AnnotationsMask').default;

exports.AnnotationsMask = AnnotationsMask;

var CommentsFull = require('./views/Comments').default;

exports.CommentsFull = CommentsFull;

var CommentsProvider = require('./components/CommentsProvider/CommentsProvider').default; // CommentsApi


exports.CommentsProvider = CommentsProvider;

var useComments = require('./hooks/useComments').default;

exports.useComments = useComments;